import { render, staticRenderFns } from "./VsDialog.vue?vue&type=template&id=6513fc08&"
import script from "./VsDialog.vue?vue&type=script&lang=ts&"
export * from "./VsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports